import { defineMessages } from "react-intl";

const SECRET_QUESTIONS = "secret-questions";

const secretQuestionsMessages = defineMessages({
  cityOfBirth: {
    id: `${SECRET_QUESTIONS}.city-of-birth`,
    defaultMessage: "City of birth?"
  },
  favoriteAnimal: {
    id: `${SECRET_QUESTIONS}.favorite-animal`,
    defaultMessage: "Favorite animal?"
  },
  favoriteBook: {
    id: `${SECRET_QUESTIONS}.favorite-book`,
    defaultMessage: "Favorite book?"
  },
  favoriteColor: {
    id: `${SECRET_QUESTIONS}.favorite-color`,
    defaultMessage: "Favorite color?"
  },
  favoritePetName: {
    id: `${SECRET_QUESTIONS}.favorite-pet-name`,
    defaultMessage: "Favorite pet's name?"
  },
  lastDigitsCreditCard: {
    id: `${SECRET_QUESTIONS}.last-digits-credit-card`,
    defaultMessage: "Last 4 digits of credit card?"
  }
});

export default secretQuestionsMessages;
